module.exports = __webpack_public_path__ + "img/Bold 2px-headphone.8623ae97.svg";